module.exports = __webpack_public_path__ + "static/media/logo-analytics.2b087730.svg";